export const REGLES_GESTION = {
    SET_ACTIF: 'SET_ACTIF',
    SET_PANNEAU_OUVERT: 'SET_PANNEAU_OUVERT',
    SET_CLE_MISE_EN_AVANT: 'SET_CLE_MISE_EN_AVANT',
};
